import * as mutations from '../store/mutations';
import {mapGetters} from 'vuex';
import $ from 'jquery';
import Swal from 'sweetalert2';

/**
 * Base of the CSS ClassName
 * @type {String}
 */
const choiceListCssClassName = 'cta-toggle-choice-list';

/**
 * Selector to retreive elements with the base className
 * @type {String}
 */
const choiceListElementSelector = `*[class*="${choiceListCssClassName}"]`;

/**
 * In order to save the cookies we choose here the key of the cookie
 * @type {String}
 */
const choiceListStateCookieKey = 'CHOICE_LIST_STATES';

/**
 * @type {number}
 */
const defaultMaximumOffer = 22;

export default {
  data() {
    return {
      choiceList: []
    };
  },
  computed: {
    ...mapGetters([
      'choices'
    ])
  },
  methods: {
    /**
     * Add a choice to the choiceList
     * We will add ONLY the stackLetter as a reference for multiple choices (cc, sepa, x1, x3)
     */
    add(stackLetter, element) {
      // https://jira.pubfac.com/jira/browse/SUPPORT-41164
      // Dont ask me why 22 plz...
      let maximumOffer = defaultMaximumOffer;

      if (typeof window.vanguardMultipleMaximumOffer === 'number') {
        maximumOffer = window.vanguardMultipleMaximumOffer;
      }

      if (this.choiceList.length > maximumOffer) {
        Swal.fire({
          title: 'Attention !',
          text: `Offre limitée à ${maximumOffer + 1} produits maximum par personne, vous devez retirer un produit pour en sélectionner un nouveau`,
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });

        return;
      }

      if (!this.choiceList.includes(stackLetter)) {
        this.choiceList.push(stackLetter);
        element.addClass('active');
        this.storeState();
      }
    },
    /**
     * Remove choice fromm choiceList
     */
    remove(stackLetter, element) {
      if (this.choiceList.includes(stackLetter)) {
        this.choiceList.splice(this.choiceList.indexOf(stackLetter), 1);
        element.removeClass('active');
        this.storeState();
      }
    },
    /**
     * Choose to add or remove the choice
     */
    toggle(stackLetter, element) {
      /**
       * Check if the stackLetter exists in the available choices
       */
      const stackLetterExists = this.choices.find(choice => choice.stackLetter === stackLetter);
      if (typeof stackLetterExists === 'undefined') {
        throw new TypeError('Any choice found with the stackLetter', stackLetter);
      }

      if (this.choiceList.includes(stackLetter)) {
        this.remove(stackLetter, element);
      } else {
        this.add(stackLetter, element);
      }
    },
    /**
     * Save the choiceList into a cookie and the store
     */
    storeState() {
      this.$store.commit(mutations.SET_CHOICE_LIST, this.choiceList);
      this.$cookies.set(choiceListStateCookieKey, JSON.stringify(this.choiceList));
      // We should store the total amount for each recurrences and paymentMethod in order to show them threw components
    }
  },
  created() {
    /**
     * Recover the state as soon as this object is constructed
     */
    let stateFromCookies = this.$cookies.get(choiceListStateCookieKey);
    if (stateFromCookies) {
      try {
        stateFromCookies = JSON.parse(stateFromCookies);
      } catch (error) {
        if (error) {
          stateFromCookies = [];
        }
      }
    } else {
      stateFromCookies = [];
    }

    /**
     * Setup the locale choiceList
     */
    this.choiceList = stateFromCookies;

    /**
     * Listen a click on a button to add/remove a choice from the list
     */
    $('body').on('click', choiceListElementSelector, e => {
      const element = $(e.currentTarget);
      const stackLetter = element.attr('data-choice-stack-letter');
      this.toggle(stackLetter, element);
    });

    /**
     * Restore button '.active' for each stackLetters
     */
    this.choiceList.forEach(stackLetter => {
      $(`*[data-choice-stack-letter="${stackLetter}"]`).addClass('active');
    });

    /**
     * Save state
     */
    this.storeState();
  }
};



// WEBPACK FOOTER //
// ./src/multiple/controllers/choice-list.js